
import '../App.css';

import { Environment, OrbitControls, Html, useProgress, useHelper, useGLTF, ScrollControls, Scroll } from '@react-three/drei';

import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { Canvas, useFrame, useLoader, useThree } from '@react-three/fiber'
import { Suspense, useEffect, useMemo, useRef, useState } from 'react';

import * as THREE from 'three'
import CameraControls from 'camera-controls'
import { Vector3 } from 'three';
import { Moon } from '../components/models/moon';
import Renderif from '../utils/renderif';
import Map from '../map';
import { useNavigate } from 'react-router-dom';
// import { Octahedron } from '../../components/models/octahedron';
// import { DirectionalLightHelper } from 'three';
// // import { useNavigate } from 'react-router-dom';
// import CameraPositionLogger from '../../components/helpers/camera_position_logger';
// import { Island } from '../../components/models/island';



function Scene() {


  //   const gltf = useLoader(GLTFLoader, 'models/island/scene.gltf')
  // const { gltf } = useGLTF(
  //     "https://virtual-school-models-bucket.s3.amazonaws.com/island/scene.gltf"
  //   );
  // const gltf = useLoader(GLTFLoader, 'https://virtual-school-models-bucket.s3.amazonaws.com/island/scene.gltf')
  const gltf = useLoader(GLTFLoader, '/models/moon2/scene.gltf')

  return <primitive object={gltf.scene} scale={[50, 50, 50]} rotation={[0, 0, 0]} />

}

function Overlay(props) {

  // console.log(props.show)
  // const navigate = useNavigate()

  useEffect(() => {
    // console.log(props.show)
    if (!props.show) {
      setTimeout(() => {
        // navigate('/home')
      }, 3000)
    }
  }, [props.show])

  return (
    <div className={`entry-overlay ${props.show ? 'opacity-0' : ''}`}>

    </div>
  )


}

function Loader() {
  const { progress } = useProgress()

  return (
    <Html >

      <div className='world-overlay'>
        <div className='d-flex flex-column align-items-center'>
          <div className='f-32 text-blue'>{progress.toFixed(0)}%</div>
          <div className='_progress'>
            <div className='_progress-bar' style={{ width: progress + '%' }}></div>
          </div>
        </div>
      </div>
    </Html>
  )
}

CameraControls.install({ THREE })

function Cloud({ momentsData, zoomToView }) {
  return <>

    {/* <mesh position={[-22, 20, 19]} onClick={(e) => {
    // zoomToView(e.object.position)
  }}>
    <boxGeometry args={[5,5,5]} />
    <octahedronGeometry  radius={10} />

    <meshStandardMaterial color={'red'} />
  </mesh> */}
    {/* <Octahedron scale={[2,2,2]}  position={[0, 38, 30]} onClick={(evt)=>{
   
    zoomToView(new Vector3(-40, 2, 40), new Vector3(-45, 2, 37))


  }}></Octahedron> */}

    <mesh position={[-47, 2, 36]} rotation={[0, 1, 1.6]} onClick={(e) => {
      <div></div>
      // zoomToView(e.object.position)
      // zoomToView(new Vector3(-35, 2, 42))
    }}>
      <boxGeometry args={[6, 6, 6]} />
      <meshStandardMaterial color={'white'} />
    </mesh>
  </>
}

function Controls({ zoom, focus, target, pos = new THREE.Vector3(), look = new THREE.Vector3(), init }) {

  const camera = useThree((state) => state.camera)

  const gl = useThree((state) => state.gl)
  const controls = useMemo(() => new CameraControls(camera, gl.domElement), [])
  controls.enabled = false;

  // console.log(controls.camera.position)
  // controls.camera.position.set(230, 200,0)
  controls.camera.lookAt(new THREE.Vector3(0, 130, 0))


  // controls.setLookAt(230, 200,0, 0, 130, 0, false)
  // controls.update()

  // console.log(zoom)

  // if(zoom){
  //     controls.setLookAt(-40, 2, 40, -45, 2, 37, true)
  //     controls.update()
  // }

  let deltaCurrent = 0

  let clock = new THREE.Clock();
  let _delta = 0;
  // 30 fps
  let interval = 1 / 15;

  return useFrame((state, delta) => {



    _delta += clock.getDelta();

    if (_delta > interval) {
      // The draw or time dependent code are here

      zoom ? pos.set(focus.x, focus.y, focus.z) : pos.set(230, 120, 0)
      zoom ? look.set(target.x, target.y, target.z) : look.set(0, 0, 0)

      state.camera.position.lerp(pos, 0.4)

      state.camera.updateProjectionMatrix()

      controls.setLookAt(state.camera.position.x, state.camera.position.y, state.camera.position.z, look.x, look.y, look.z, true)
      _delta = _delta % interval;

    }
    return controls.update(delta)


    // zoom ? pos.set(focus.x, focus.y, focus.z) : pos.set(230, 120, 0)
    // zoom ? look.set(target.x, target.y, target.z ) : look.set(0, 0, 0)

    // state.camera.position.lerp(pos, init ? 0.2 : 0.4)

    // state.camera.updateProjectionMatrix()

    // controls.setLookAt(state.camera.position.x, state.camera.position.y, state.camera.position.z, look.x, look.y, look.z, true)

    // return controls.update(delta)
  })


}


function Light() {
  const dirLight = useRef(null);
  //   useHelper(dirLight, DirectionalLightHelper,1, "red");

  return (
    <>
      <directionalLight position={[0, 100, -100]} color={"white"} castShadow={true} intensity={5} ref={dirLight} />
    </>
  );
};

function Home() {

  const [zoom, setZoom] = useState(false)
  const [focus, setFocus] = useState({})
  const [target, setTarget] = useState({})
  const [_init, _setInit] = useState(true)
  const [loading, setLoading] = useState(true)

  const navigate = useNavigate()

  const { progress } = useProgress()

  const [call, setCall] = useState(0)

  const [state, setState] = useState({
    services_rotation: 0,
    services_index: 0,
    base_active: {
      info: null,
      clientX: 100,
      clientY: 100
    },
    bases: [
      {
        place: 'Morelia, México',
        description: 'Nuestra base principal de operaciones, donde llevamos a cabo la mayoría de nuestros desarrollos y estrategias, manteniendo siempre una cercanía con el cliente latinoamericano.'
      },
      {
        place: 'USA',
        description: 'Enfocados en innovación y crecimiento, desde esta base ofrecemos soluciones para el mercado norteamericano, asegurando la vanguardia en cada proyecto'
      },
      {
        place: 'France',
        description: 'Nuestra conexión con Europa. Desde aquí, desarrollamos proyectos de alto impacto para expandir nuestras propuestas al mercado europeo, aportando una perspectiva internacional'
      }

    ]
  })

  const base_info = useRef(null);

  useEffect(() => {
    window.addEventListener("resize", resize);
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, [])

  const resize = (evt) => {

    state.base_active.clientX = 0
    state.base_active.clientY = 0
    state.base_active.info = null

    setState({ ...state })

  }


  const init = [230, 120, 0]
  useEffect(() => {
    if (loading === true && progress == 100) {
      setTimeout(() => {
        setLoading(false)
      }, 100)
    }

  }, [progress])

  return (
    <div className="App">





      {/* <Overlay show={_init}></Overlay> */}

      {/* <div className={`entry-overlay-2 ${!loading? 'opacity-0':''}`}>
        
        <div className={`flex-column justify-content-center align-items-center h-100 ${progress === 100 ? 'd-none':'d-flex'}`}>
            <div className='f-32 text-blue lighter'>{progress.toFixed(0)}%</div>
            <div className='_progress'>
              <div className='_progress-bar' style={{width:progress+'%'}}></div>
            </div>
        </div>

      </div>
     */}
      <Canvas linear camera={{ fov: 40, near: 1, far: 700, position: [230, 0, 0] }}
        shadows={true}>

        <Suspense fallback={null}>



          {/* <axesHelper args={[1000]}></axesHelper> */}

          {/* <hemisphereLight color={"red"} intensity={10} position={[0, 500, 0 ]} ></hemisphereLight> */}
          <ambientLight color={"#e84444"} intensity={10} />
          {/* <Light></Light> */}

          {/* <directionalLight position={[0, 0, 0]} color={"white"} intensity={10} castShadow={true} ref={dirLight} /> */}

          {/* <Watermelon scale={[0.1,0.1,0.1]}></Watermelon> */}
          {/* <Pirate scale={[20,20,20]}></Pirate> */}
          {/* <Cloud  zoomToView={(focusRef, _target) => {
            _setInit(false)
            setZoom(true) 
            setFocus(focusRef) 
            setTarget(_target)
          }} /> */}

          {/* <mesh position={[0,10,0]} onClick={(e) => {
            // zoomToView(e.object.position)
          }}>
            <boxGeometry args={[5, 5, 5]} />
            <meshStandardMaterial color={'red'} />
          </mesh> */}

          {/* <Scene></Scene> */}

          <ScrollControls pages={4} >

            <Scroll html id="scroll">
              <div className='page'>
                <img className='logo' src='./assets/10.svg'></img>
                <div className='fraktal-name'>FRAKTALWEB</div>
              </div>

              <div className="page d-flex flex-wrap justify-content-center align-items-center">

                <div className='col-12 col-lg-6'></div>

                <div className='col-12 col-lg-5'>
                  <div className='text-white f-title f-128 text-reflect text-center'>WE ARE</div>
                  <div className='text-white f-primary f-16 mt-4 line-1 px-3 p-lg-0'>
                    Fraktalweb Agency, una empresa de desarrollo de software ultra personalizado que se dedica a resolver problemas operativos y optimizar procesos empresariales utilizando la última tecnología. Nos especializamos en ofrecer soluciones que no solo son altamente funcionales y escalables, sino también pensadas a medida para cada cliente. 
                  </div>

                  <div className='text-white f-primary f-16  line-1 px-3 p-lg-0 mt-4'>
                    Cada misión comienza con una elección estratégica:
                    <ul className='mt-2'>
                      <li> Si tienes claro tu objetivo y buscas una solución a medida basada en un análisis detallado. <br />  <div className='cta cta--outline mt-2' onClick={() => {
                        window.open('https://fraktalweb.com/brief', '_blank')
                      }}>Start MISSION</div></li>
                      <li className='mt-4'> Contácta con nuestros expertos para definir la mejor estrategia.

                        <div className='cta cta--outline mt-2' onClick={() => {
                          window.open('https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ3ONDl_SQmaZGmvfOSN-Cg71BNv3zYtnIcCSA7c0F4LgeGKjgvU__BhV_79wwqCGvWkAc-THqY4 ', '_blank')
                        }}>Agendar cita</div>

                      </li>
                    </ul>
                    <p className='mt-4'>Toma el control y llevemos tu proyecto más allá de los límites convencionales.</p>
                  </div>

                  <div className='container d-flex justify-content-start py-5'>
                    {/* <div className='cta'>START MISSION</div>
                        <div className='mx-3'></div> */}


                  </div>


                </div>
                <div className='col-1'></div>
                {/* <div className='fraktal-name'>FRAKTALWEB</div> */}
              </div>

              <div className='page d-flex flex-column'>

                {/* <div className='col-6'>a</div>
                <div className='col-6'>a</div> */}
                <div className='services-frame' style={{ transform: `rotateZ(${state.services_rotation}deg) scale(1)` }}>





                  <div className='col-2'></div>
                  <div className='col-2  d-flex justify-content-center '><div className='dot' style={{ marginBottom: '40%' }} onClick={(evt) => {
                    setState({ ...state, services_rotation: -40, services_index: -2 })
                    setCall(-1)
                  }}></div></div>
                  <div className='col-2  d-flex justify-content-center '><div className='dot' style={{ marginTop: '0%' }} onClick={(evt) => {
                    setState({ ...state, services_rotation: -19, services_index: -1 })
                    setCall(-0.5)
                  }}></div></div>
                  <div className='col-2  d-flex justify-content-center '><div className='dot' style={{ marginBottom: '0%' }} onClick={(evt) => {
                    setState({ ...state, services_rotation: 0, services_index: 0 })
                    setCall(0)
                  }}></div></div>
                  <div className='col-2  d-flex justify-content-center '><div className='dot' style={{ marginTop: '-50%' }} onClick={(evt) => {
                    setState({ ...state, services_rotation: 19, services_index: 1 })
                    setCall(0.5)
                  }}></div></div>
                  <div className='col-2'></div>
                  {/*  <div className='col-2  d-flex justify-content-center '><div className='dot' style={{ marginBottom: '55%' }} onClick={(evt) => {
                    setState({ ...state, services_rotation: 40, services_index: 2 })
                    setCall(1)
                  }}></div></div> */}









                </div>

                <div className='services-text'>
                  <Renderif isTrue={state.services_index === -2}>
                       <div className='container  d-flex flex-wrap justify-content-center mt-5'>
                      <div className='col-12 col-lg-1'></div>
                      <div className='col-12 col-lg-10'>
                        {/* <div className='f-32 text-white text-center line-1 f-title'>WEB DESING</div> */}
                        <div className='text-white f-title f-56 text-reflect-48 text-center'>Brand Management</div>

                        <div className='text-white f-primary f-16 text-center line-1 mt-4'>Ofrecemos una administración integral de tu marca, ajustada a las fases en las que se encuentra tu empresa. Evaluamos las necesidades esenciales y desplegamos una serie de herramientas tecnológicas que le dan el impulso que necesitas para destacar en el mercado.</div>
                      </div>
                      <div className='col-12 col-lg-1'></div>
                    </div>
                    <div className='container d-flex justify-content-center py-5'>
                      {/* <div className='cta'>START MISSION</div>
                        <div className='mx-3'></div> */}
                      <div className='cta cta--outline' onClick={() => {
                        navigate('brand-management');
                      }}>Ver más</div>

                      <div className='cta cta--outline ms-4' onClick={() => {
                        window.open('https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ3ONDl_SQmaZGmvfOSN-Cg71BNv3zYtnIcCSA7c0F4LgeGKjgvU__BhV_79wwqCGvWkAc-THqY4 ', '_blank')
                      }}>Agendar cita</div>

                    </div>
                   
                  </Renderif>
                  <Renderif isTrue={state.services_index === -1}>
                    <div className='container d-flex justify-content-center mt-5'>
                      <div className='col-12 col-lg-1 '></div>
                      <div className='col-12 col-lg-10 '>
                        <div className='f-56 text-white text-center text-reflect-48 f-title'>Dedicated Web Development</div>
                        <div className='text-white f-primary f-16 text-center mt-4 line-1'>Desarrollamos sitios web que van más allá de lo tradicional. Con nuestro análisis profundo, no solo tendrás presencia en línea, sino una herramienta especializada que convierte tu sitio en un activo estratégico para tu negocio</div>

                      </div>
                      <div className='col-12 col-lg-1 '></div>
                    </div>
                    <div className='container d-flex justify-content-center py-5'>
                      {/* <div className='cta'>START MISSION</div>
                        <div className='mx-3'></div> */}
                      <div className='cta cta--outline' onClick={() => {
                        navigate('web-development');
                      }}>Ver más</div>
                      <div className='cta cta--outline ms-4' onClick={() => {
                        window.open('https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ3ONDl_SQmaZGmvfOSN-Cg71BNv3zYtnIcCSA7c0F4LgeGKjgvU__BhV_79wwqCGvWkAc-THqY4 ', '_blank')
                      }}>Agendar cita</div>
                    </div>
                  </Renderif>
                  <Renderif isTrue={state.services_index === -0}>
                  <div className='container d-flex justify-content-center mt-5'>
                      <div className='col-12 col-lg-1'></div>
                      <div className='col-12 col-lg-10'>
                        <div className='f-56 text-white text-center  text-reflect-48 f-title'>Custom Software Development</div>
                        <div className='text-white f-primary f-16 text-center mt-4 line-1'>Creamos software 100% personalizado para resolver problemas de efectividad, tanto internos como externos, dentro de un negocio. Analizamos a detalle cada problemática y ofrecemos una herramienta clara y escalable. No importa el proceso, ¡hay un sistema que puede optimizarlo y resolverlo!</div>
                      </div>
                      <div className='col-12 col-lg-1'></div>
                    </div>
                    <div className='container d-flex justify-content-center py-5'>
                      {/* <div className='cta'>START MISSION</div>
                        <div className='mx-3'></div> */}
                      <div className='cta cta--outline' onClick={() => {
                        navigate('software-development');
                      }}>Ver más</div>
                      <div className='cta cta--outline ms-4' onClick={() => {
                        window.open('https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ3ONDl_SQmaZGmvfOSN-Cg71BNv3zYtnIcCSA7c0F4LgeGKjgvU__BhV_79wwqCGvWkAc-THqY4 ', '_blank')
                      }}>Agendar cita</div>
                    </div>

                  </Renderif>
                  <Renderif isTrue={state.services_index === 1}>
                    <div className='container d-flex justify-content-center mt-5'>
                      <div className='col-12 col-lg-1'></div>
                      <div className='col-12 col-lg-10'>
                        <div className='text-white f-title f-56 text-reflect-48 text-center'>Specialized Mobile Applications </div>
                        <div className='text-white f-primary text-center line-1 mt-4'>Creamos aplicaciones móviles totalmente personalizadas, escalables y prácticas, alineadas a las necesidades de tu empresa. Realizamos un análisis profundo y seleccionamos la tecnología más adecuada para que tu aplicación sea funcional y eficiente.</div>
                      </div>
                      <div className='col-12 col-lg-1'></div>
                    </div>
                    <div className='container d-flex justify-content-center py-5'>
                      {/* <div className='cta'>START MISSION</div>
                        <div className='mx-3'></div> */}
                      <div className='cta cta--outline' onClick={() => {
                        navigate('app-solutions');
                      }}>Ver más</div>
                      <div className='cta cta--outline ms-4' onClick={() => {
                        window.open('https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ3ONDl_SQmaZGmvfOSN-Cg71BNv3zYtnIcCSA7c0F4LgeGKjgvU__BhV_79wwqCGvWkAc-THqY4 ', '_blank')
                      }}>Agendar cita</div>
                    </div>
                  </Renderif>
                  <Renderif isTrue={state.services_index === 2}>
                    <div className='container d-flex justify-content-center'>
                      <div className='col-1'></div>
                      <div className='col'>
                        <div className='f-32 text-white text-center line-1 f-title'></div>
                        <div className='text-white f-primary text-center line-1'>.</div>
                      </div>
                      <div className='col-1'></div>
                    </div>
                  </Renderif>


                </div>






                {/* <div className='fraktal-name cursor-pointer' onClick={(evt)=>{
                    setCall(evt)
                  }}>FRAKTALWEB</div> */}
              </div>

              {/* 
              <div className='page'>


                <div className='d-flex flex-column mt-5' style={{
                  position: 'relative',
                  top: '10%',
                  width: 'calc(100% - 20%)',
                  left: '10%'
                }}>
                  <div className='text-white f-title f-56 text-reflect-48'>SPACE BASES</div>
                  <div className='text-white f-primary line-1 pe-5 mt-4'>Estas bases nos permiten estar al tanto de las tendencias globales y <br></br> adaptar nuestras soluciones a diversas necesidades culturales y de mercado.</div>
                </div>

                <div className='map-frame'>

                  <Renderif isTrue={state.base_active.info !== null}>
                    <div ref={base_info} className='base_info' style={{
                      left: state.base_active?.clientX - 130,
                      top: state.base_active?.clientY - 130
                    }}>
                      <div className='f-12 bold text-white f-primary'>{state.base_active.info?.place}</div>
                      <div className='f-12 text-white f-primary mt-2'>{state.base_active.info?.description}</div>
                      <div className='f-12 bold text-white f-primary mt-2'>hello@fraktalweb.com</div>
                    </div>
                  </Renderif>



                  <div className='d-block d-lg-none'>
                    <div ref={base_info} className='base mb-2 mt-5'>
                      <div className='f-12 bold text-white f-primary'>{state.bases[0]?.place}</div>
                      <div className='f-12 text-white f-primary mt-2'>{state.bases[0]?.description}</div>
                      <div className='f-12 bold text-white f-primary mt-2'>hello@fraktalweb.com</div>
                    </div>

                    <div ref={base_info} className='base mb-2'>
                      <div className='f-12 bold text-white f-primary'>{state.bases[1]?.place}</div>
                      <div className='f-12 text-white f-primary mt-2'>{state.bases[1]?.description}</div>
                      <div className='f-12 bold text-white f-primary mt-2'>hello@fraktalweb.com</div>
                    </div>

                    <div ref={base_info} className='base mb-2'>
                      <div className='f-12 bold text-white f-primary'>{state.bases[2]?.place}</div>
                      <div className='f-12 text-white f-primary mt-2'>{state.bases[2]?.description}</div>
                      <div className='f-12 bold text-white f-primary mt-2'>hello@fraktalweb.com</div>
                    </div>
                  </div>




                  {/* <img className='d-block mx-auto border position-absolute' style={{left:'7.5%', top:'19.7%'}} width={'85%'} src='assets/mapa.svg'></img> * /}

                  <Map onClickBase={(value) => {
                    // console.log(value)
                    state.base_active.clientX = value.clientX
                    state.base_active.clientY = value.clientY
                    state.base_active.info = value.info

                    setState({ ...state })
                  }}></Map>




                </div>

                
              </div>  {/* end space bases page*/}




              <div className='page'>

                <div className='d-flex flex-column mt-5' style={{
                  position: 'relative',
                  top: '40%',
                  width: 'calc(100% - 20%)',
                  left: '10%'
                }}>
                  <div className='text-white f-title f-56 text-reflect-48'>CONTACT US</div>
                  <div className='text-white f-primary line-1 pe-5 mt-4'>¿Tienes una misión? ¡Conversemos!</div>



                  <div
                    className="d-flex justify-content-center text-center flex-wrap w-100 mt-5"
                    style={{

                      borderTop: '1px solid #ffffff57',
                      borderBottom: '1px solid #ffffff57',
                    }}
                  >
                    <p
                      className="f-primary line-1 p-5 "
                      style={{ borderRight: '1px solid #ffffff57' }}
                    >
                      <a
                        href="https://wa.me/524435144579"
                        className="text-white text-decoration-none"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        +52 443 514 45 79
                      </a>
                    </p>
                    <p
                      className="f-primary line-1 p-5 "
                      style={{ borderRight: '1px solid #ffffff57' }}
                    >
                      <a
                        href="mailto:hello@fraktalweb.com"
                        className="text-white text-decoration-none"
                      >
                        hello@fraktalweb.com
                      </a>
                    </p>
                    <p className="d-flex justify-content-center align-items-center p-5 m-0">
                      <a
                        href="https://www.facebook.com/fraktalwebAgency"
                        target="_blank"
                        rel="noopener noreferrer"
                      >

                        <svg fill="#ffffff" width={40} height={40} viewBox="0 0 256 256" id="Flat" xmlns="http://www.w3.org/2000/svg" strokeWidth="#ffffff"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M228,128A100,100,0,1,0,127.98877,228l.01123.001.01123-.001A100.11345,100.11345,0,0,0,228,128Zm-96,91.90771V148.001h28a4,4,0,0,0,0-8H132v-28a20.02229,20.02229,0,0,1,20-20h16a4,4,0,0,0,0-8H152a28.03145,28.03145,0,0,0-28,28v28H96a4,4,0,0,0,0,8h28v71.90673a92,92,0,1,1,8,0Z"></path> </g></svg>
                      </a>
                      <a
                        href="https://instagram.com/fraktalweb/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="ms-2"
                      >

                        <svg fill="#ffffff" width={40} height={40} viewBox="0 0 256 256" id="Flat" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M128,84a44,44,0,1,0,44,44A44.04978,44.04978,0,0,0,128,84Zm0,80a36,36,0,1,1,36-36A36.04061,36.04061,0,0,1,128,164ZM172,32H84A52.059,52.059,0,0,0,32,84v88a52.059,52.059,0,0,0,52,52h88a52.059,52.059,0,0,0,52-52V84A52.059,52.059,0,0,0,172,32Zm44,140a44.04978,44.04978,0,0,1-44,44H84a44.04978,44.04978,0,0,1-44-44V84A44.04978,44.04978,0,0,1,84,40h88a44.04978,44.04978,0,0,1,44,44ZM188,76a8,8,0,1,1-8-8A8.00917,8.00917,0,0,1,188,76Z"></path> </g></svg>
                      </a>
                      <a
                        href="https://www.linkedin.com/company/fraktalweb"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="ms-2"
                      >

                        <svg fill="#ffffff" width={40} height={40} viewBox="0 0 256 256" id="Flat" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M96,80a8,8,0,1,1-8-8A7.99993,7.99993,0,0,1,96,80Zm-8,28.001a4,4,0,0,0-4,4v64a4,4,0,1,0,8,0v-64A4,4,0,0,0,88,108.001Zm60,0a31.92463,31.92463,0,0,0-24,10.86767V112.001a4,4,0,0,0-8,0v64a4,4,0,1,0,8,0v-36a24,24,0,0,1,48,0v36a4,4,0,1,0,8,0v-36A32.03619,32.03619,0,0,0,148,108.001ZM224,44V212a12.01375,12.01375,0,0,1-12,12H44a12.01375,12.01375,0,0,1-12-12V44A12.01359,12.01359,0,0,1,44,32H212A12.01359,12.01359,0,0,1,224,44Zm-8,0a4.00458,4.00458,0,0,0-4-4H44a4.00458,4.00458,0,0,0-4,4V212a4.00458,4.00458,0,0,0,4,4H212a4.00458,4.00458,0,0,0,4-4Z"></path> </g></svg>
                      </a>
                    </p>
                  </div>



                </div>


              </div>{/* end page contact*/}




            </Scroll>

            <Moon call={call}></Moon>
          </ScrollControls>
          {/* <OrbitControls /> */}
          {/* <Island></Island> */}
          {/* {
            !loading ? <Controls zoom={zoom} focus={focus} target={target} init={_init}/> : <></>
          }
           */}


          {/* <CameraPositionLogger event='click'></CameraPositionLogger> */}


        </Suspense>
      </Canvas>




      <div className='space-bg'>

        <div className='stars'></div>
        <div className='twinkling'></div>
      </div>













      <div className='d-none'>
        <button onClick={() => {

          setZoom(true)
          setFocus(new Vector3(-20.75, 1, 20))
        }}> GO to 1</button>


        <div>

          <div className='border w-100'>
            {focus.x === undefined ? init[0] : focus.x}
            <input className='w-100' type='range' min={-200} max={200} value={focus.x === undefined ? init[0] : focus.x} step={1} onChange={(evt) => {
              setZoom(true)
              setFocus(new Vector3(evt.currentTarget.value, focus.y, focus.z))
            }} />
          </div>

          <div className='border w-100'>
            {focus.y === undefined ? init[1] : focus.y}
            <input className='w-100' type='range' min={-200} max={200} value={focus.y === undefined ? init[1] : focus.y} step={1} onChange={(evt) => {
              setZoom(true)
              setFocus(new Vector3(focus.x, evt.currentTarget.value, focus.z))
            }} />
          </div>

          <div className='border w-100'>
            {focus.z === undefined ? init[2] : focus.z}
            <input className='w-100' type='range' min={-200} max={200} value={focus.z === undefined ? init[2] : focus.z} step={1} onChange={(evt) => {
              setZoom(true)
              setFocus(new Vector3(focus.x, focus.y, evt.currentTarget.value))
            }} />
          </div>
        </div>





        <button onClick={() => {
          setZoom(true)
          setFocus(new Vector3(init[0], init[1], init[2]))
          setTarget(new Vector3(0, 0,))
        }}> Reset</button>
      </div>


    </div>
  );
}

export default Home;




